import { faultBit, featureKey } from "constant";
import _ from "lodash";
import { siteSettingsData } from "redux/reduxToolkitServices/_commonReducers/commonReducers";

export const  doesCarHaveCriticalFault = function (gpsiCarId) {
    if (!siteSettingsData?.Features.indexOf(featureKey.power) >= 0) return false;
    let activeCriticalFaults =
         faultBit.FieldMissing |
         faultBit.HwFailSafe |
         faultBit.MainDriverOff |
         faultBit.MainDriverOn |
         faultBit.MainWelded |
         faultBit.MShorted |
         faultBit.SpeedSensorFault;

      let persistentCriticalFaults = faultBit.FieldMissing | faultBit.HwFailSafe | faultBit.MShorted | faultBit.InoperableCharger;
    let isCriticalFault = function (activeFaults, persistentFaults) {
        return (activeFaults & activeCriticalFaults || persistentFaults & persistentCriticalFaults);
     };
    let allFaults = [];
    let fault = _.find(allFaults, { GpsiCarId: gpsiCarId });
    return (fault !== undefined) ? isCriticalFault(fault.ActiveFaults, fault.PersistentFaults) : false;
 };